<div class="company-select-dialog">
  <div class="title">Select company</div>
  @if (projectName) {
    <div class="subtitle">{{ projectName }}</div>
  }
  <p class="description">Company is required for using the warehouse location</p>

  @if (loading) {
    <div class="loading">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Loading companies…</span>
    </div>
  } @else if (companies.length === 0) {
    <div class="empty">No companies available for this project.</div>
  } @else {
    <mat-form-field appearance="fill" class="company-field">
      <mat-label>Company</mat-label>
      <mat-select [(value)]="selectedCompanyId">
        @for (company of companies; track company.id) {
          <mat-option [value]="company.id">
            @if (company.companyNo && company.companyName) {
              ({{ company.companyNo }}) - {{ company.companyName }}
            } @else {
              {{ company.companyName || company.companyNo || company.id }}
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <div class="actions">
    <button mat-flat-button class="cancel" (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" class="confirm" [disabled]="!canConfirm()" (click)="confirm()">
      Confirm
    </button>
  </div>
</div>
